"use strict";
/**
 * Legacy Polymarket (CLOB) positions: the one venue without a server position
 * cache. Every other venue answers POST /positions
 * (orders/order-page-positions.ts).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPolymarketPosition = fetchPolymarketPosition;
const polymarket_api_1 = require("../polymarket-api");
/**
 * Fetch current position from Polymarket
 * @param marketId - Market slug or ID
 * @param conditionId - Condition ID for the market
 * @param clobTokenIds - Array of token IDs [yesTokenId, noTokenId] for finding positions
 * @returns Position data or null if no position
 */
async function fetchPolymarketPosition(marketId, conditionId, clobTokenIds) {
    if (!conditionId) {
        console.warn("No conditionId provided for Polymarket position fetch");
        return {
            ticker: marketId,
            yes_quantity: 0,
            no_quantity: 0,
            quantity: 0,
            market_exposure: 0,
            realized_pnl: 0,
        };
    }
    // Fetch positions for this market using conditionId (server-side filtering)
    const positions = await (0, polymarket_api_1.getPositions)(conditionId);
    // Find positions for this market's tokens
    const yesTokenId = clobTokenIds?.[0];
    const noTokenId = clobTokenIds?.[1];
    const yesPosition = yesTokenId
        ? positions.find((p) => p.asset === yesTokenId)
        : undefined;
    const noPosition = noTokenId
        ? positions.find((p) => p.asset === noTokenId)
        : undefined;
    const yes_quantity = yesPosition ? yesPosition.size : 0;
    const no_quantity = noPosition ? noPosition.size : 0;
    // Calculate total exposure and PnL
    const yesValue = yesPosition ? yesPosition.currentValue : 0;
    const noValue = noPosition ? noPosition.currentValue : 0;
    const yesPnl = yesPosition ? yesPosition.cashPnl : 0;
    const noPnl = noPosition ? noPosition.cashPnl : 0;
    return {
        ticker: marketId,
        yes_quantity,
        no_quantity,
        quantity: Math.abs(yes_quantity - no_quantity),
        market_exposure: yesValue + noValue,
        realized_pnl: yesPnl + noPnl,
    };
}
